/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerGetVersionHistoryQueryResponse, DocumentsControllerGetVersionHistoryPathParams, DocumentsControllerGetVersionHistory401, DocumentsControllerGetVersionHistory403 } from "../../models/documentsController/DocumentsControllerGetVersionHistory";

function getDocumentsControllerGetVersionHistoryUrl(id: DocumentsControllerGetVersionHistoryPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/versions` as const }  
  return res
}

/**
 * @summary Get version history for a document
 * {@link /api/v1/documents/:id/versions}
 */
export async function documentsControllerGetVersionHistory(id: DocumentsControllerGetVersionHistoryPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<DocumentsControllerGetVersionHistory401 | DocumentsControllerGetVersionHistory403>, unknown>({ method : "GET", url : getDocumentsControllerGetVersionHistoryUrl(id).url.toString(), ... requestConfig })  
  return res.data
}